/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SubgroupsQueryResponse } from '../../types/GetV1Subgroups.ts'

export const getV1SubgroupsQueryKey = () => [{ url: '/v1/Subgroups' }] as const

export type GetV1SubgroupsQueryKey = ReturnType<typeof getV1SubgroupsQueryKey>

/**
 * {@link /v1/Subgroups}
 */
export async function getV1Subgroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1SubgroupsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Subgroups`,
        ...requestConfig,
    })
    return res
}

export function getV1SubgroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SubgroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SubgroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SubgroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Subgroups(config)
        },
    })
}

/**
 * {@link /v1/Subgroups}
 */
export function useGetV1Subgroups<
    TData = ResponseConfig<GetV1SubgroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1SubgroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1SubgroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SubgroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SubgroupsQueryKey()

    const query = useQuery(
        {
            ...getV1SubgroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
